/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {Suspense, useEffect, useRef} from "react";
import {useDispatch} from "../useDispatch";
import {useTypedSelector} from "helpers/reducers";
import "assets/ExtraStyle.css";
import Popup from "pages/Front/components/Popup";
import SessionAction from "store/session/SessionAction";
import LanguageNew from "pages/Front/components/LanguageNew";
import LogoNew from "pages/Front/components/LogoNew";
import BookingHeaderBreadcrumb from "pages/Front/Booking/components/BookingHeaderBreadcrumb";
import BookingLoginButtonNew from "pages/Front/Booking/components/BookingLoginButtonNew";
import SellerNotificationsDropdown from "pages/Front/Booking/Seller/components/SellerNotificationsDropdown";

interface UnloggedLayoutFullWidthProps {
    children: React.ReactNode | React.ReactNode[];
    hideLogin?: boolean;
    showNotification?: boolean;
}

const UnloggedLayoutFullWidth = (props: UnloggedLayoutFullWidthProps) => {
    const scrollingRef = useRef<HTMLDivElement | null>(null);
    const dispatch = useDispatch();

    //if no language is set, use hall language
    const hallLanguage = useTypedSelector(state => state.hallState.hall?.language?.code);
    const language = useTypedSelector(state => state.sessionState).language?.code || hallLanguage;

    useEffect(() => {
        if (language) {
            dispatch(SessionAction.setLanguage(language));
        }
    }, []);

    useEffect(() => {
        scrollingRef.current!.scrollTo(0, 0);
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div className="UnloggedLayoutFullWidth relative bg-white flex flex-grow">
                <div className="UnloggedLayoutFullWidthOuter w-full flex-grow flex flex-col justify-center z-2 relative">
                    <div className={"UnloggedLayoutFullWidthHeaderBackground border-b border-solid "}>
                        <div
                            className={
                                "UnloggedLayoutFullWidthHeader max-w-full relative flex justify-between sm:justify-between items-center m-auto w-full py-2 sm:py-2 lg:py-4 px-4"
                            }
                        >
                            <LogoNew />
                            <div className={"relative flex flex-row justify-center items-center space-x-2 lg:space-x-4"}>
                                {!props?.hideLogin && (
                                    <BookingLoginButtonNew />
                                )}
                                {props?.showNotification && (
                                    <div className={"relative"}>
                                        <SellerNotificationsDropdown />
                                    </div>
                                )}
                                <LanguageNew />
                            </div>
                        </div>
                    </div>
                    <div className={"relative flex flex-col flex-grow w-full"}>
                        <BookingHeaderBreadcrumb isFullWidth={true} />
                        <div ref={scrollingRef} className={"bg-gray-100 UnloggedLayoutFullWidthInner flex-grow flex flex-col"} role="document">
                            {/*must be block for ios devices */}
                            <div className={"block flex-col flex-grow m-auto justify-between w-full"}>{props.children}</div>
                        </div>
                    </div>
                </div>
                <Popup />
                <div className="ref"></div>
            </div>
        </Suspense>
    );
};
export default UnloggedLayoutFullWidth;
